import styled from 'styled-components';

export const PageSubtitleTextBlockWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
